<div dialog-header>
  <h4>Report Problem</h4>
  <button class="close-btn" (click)="close()">
    <app-icon name="cross" width="16px" height="16px" />
  </button>
</div>

@if (!submitted) {
  <form [formGroup]="requestForm">
    <app-input-control formControlName="email" />
    <app-dropdown formControlName="category" label="Category">
      @for (opt of categoryTypes; track opt) {
        <app-dropdown-option [value]="opt.code">
          {{ opt.name }}
        </app-dropdown-option>
      }
    </app-dropdown>
    <app-input-control formControlName="details" placeholder="Additional Details" />
    @if (img) {
      <div class="image-block">
        <img [src]="img" alt="Problem Screen" />
      </div>
    }
  </form>
}

@if (submitted) {
  <p>Your request has been sent!</p>
}

<div dialog-actions>
  @if (!submitted) {
    <button ui-button type="success" (click)="submit()" [disabled]="!requestForm.valid">Submit</button>
  }
  <button ui-button [type]="submitted ? 'success' : 'danger'" (click)="close()">
    {{ submitted ? 'Continue' : 'Cancel' }}
  </button>
</div>
